import { useNow } from './hooks';
import { CLOCK_LABEL, timeInState, type ClockState } from './time';
import { cx } from './cx';

export interface TimeInStateProps {
  /** ISO time the record entered its current state. */
  since: string;
  /** The record's clock, if it has one. Colours the label. */
  clock?: ClockState | undefined;
  /** Text after the duration, for example "at port". */
  suffix?: string;
  /** Fixed "now", for tests and static renders. Otherwise the label ticks every minute. */
  now?: number;
  className?: string;
}

export function TimeInState({ since, clock, suffix, now, className }: TimeInStateProps) {
  const tick = useNow();
  const t = timeInState(since, now ?? tick);
  if (!t) return <span className={cx('eb-time', className)}>—</span>;
  const label = suffix ? `${t.label} ${suffix}` : t.label;
  return (
    <span
      className={cx('eb-time', className)}
      data-clock={clock}
      title={`Since ${new Date(since).toLocaleString()}${clock ? `, ${CLOCK_LABEL[clock]}` : ''}`}
    >
      {label}
      {clock ? <span className="eb-sr"> ({CLOCK_LABEL[clock]})</span> : null}
    </span>
  );
}
